import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ChakraProvider } from '@/components/ui/lib/chakra-provider';
import { queryClient } from '@/lib/query-client';
import { reactPlugin } from '@/lib/app-insights';
import { router } from '@/app/router';
import { chakraSystem } from '@/lib/chakra-system';
import SaveToast from '@/components/ui/save-toast';
import AppErrorBoundary from '@/components/ui/app-error-boundary';
import type { AppProviderProps } from '@/types/app-provider';

const AppProvider = (_props: AppProviderProps) => {
  return (
    <AppErrorBoundary>
      <AppInsightsContext value={reactPlugin}>
        <QueryClientProvider client={queryClient}>
          <ChakraProvider value={chakraSystem}>
            <RouterProvider router={router} />
            <SaveToast />
          </ChakraProvider>
        </QueryClientProvider>
      </AppInsightsContext>
    </AppErrorBoundary>
  );
};

export default AppProvider;
